/**
 * The production Cockpit — the one origin every Desk door out to the Cockpit
 * shares: account, the Google and Gmail consent doors, the product Inbox, and
 * booking pages. It mirrors the server's default handoff
 * origin in `apps/server/src/neucleos/publicConfig.ts`. Keeping a single copy
 * on the web side is what stops two Settings eras from drifting onto
 * different hosts (Settings V2 once carried `app.neucleos.com`, a host that
 * does not resolve, so every Cockpit door on it opened nothing).
 */
export const COCKPIT_ORIGIN = "https://cockpit-1.neucleos.app";
